import { Skeleton } from "@/components/ui/skeleton";

/** Board-shaped placeholder: gray columns with card outlines. */
export const BoardSkeleton = ({ columns = 4 }: { columns?: number }) => (
  <div className="flex h-full min-h-0 w-full gap-3 overflow-hidden" aria-busy>
    {Array.from({ length: columns }, (_, column) => (
      <div
        key={column}
        className="flex min-w-[17rem] flex-1 basis-0 flex-col gap-2 rounded-xl bg-muted/60 p-2"
      >
        <Skeleton className="mx-1 mt-1.5 mb-1 h-3.5 w-24" />
        {Array.from({ length: 3 - (column % 2) }, (_, card) => (
          <div key={card} className="space-y-2 rounded-lg border bg-card p-3">
            <Skeleton className="h-4 w-4/5" />
            <Skeleton className="h-3 w-3/5" />
            <Skeleton className="h-3 w-2/5" />
          </div>
        ))}
      </div>
    ))}
  </div>
);
